import React, { useEffect } from 'react';

const typeStyles = {
    success: 'bg-green-500',
    error: 'bg-red-500',
    info: 'bg-blue-500',
    warning: 'bg-yellow-500 text-black',
};

export default function Notification({ id, message, type = 'info', onClose, duration  }) {
    useEffect(() => {
        const timer = setTimeout(() => onClose(id), duration);
        return () => clearTimeout(timer);
    }, [id, onClose, duration]);

    return (
        <div className={`max-w-sm w-full ${typeStyles[type]} text-white px-4 py-2 rounded-lg shadow-lg mb-4 animate-slide-in`}>
            <div className="flex justify-between items-center">
                <span>{message}</span>
                <button onClick={() => onClose(id)} className="ml-4 text-white font-bold">×</button>
            </div>
        </div>
    );
}
